import script from "./LeftTab.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftTab.vue?vue&type=script&setup=true&lang=js"

import "./LeftTab.vue?vue&type=style&index=0&id=3814edab&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3814edab"]])

export default __exports__